import React from "react";
import Maps from "./status/maps";
import ZonesControl from '@src/core/features/zones/components/zones-control';

const HistoryMap: React.FC = () => {

  return (
    <React.Fragment>
      <Maps />
      
      <ZonesControl />
    </React.Fragment>
  );
};

export default HistoryMap;
